import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { saleHistory } from "../redux/saleSlice";
import SaleInvoiceModal from "./SaleInvoice";
import { ToastContainer, toast } from "react-toastify";
import { FaFileInvoice } from "react-icons/fa";
export default function SellHistory() {
  const dispatch = useDispatch();
  const [invoiceData, setInvoiceData] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const [visible, setVisible] = useState(false);
  const { salehistory, loading } = useSelector((state) => state.sales);

  useEffect(() => {
    dispatch(saleHistory());
  }, [dispatch]);

  const handleInvoice = (item) => {
    setInvoiceData(item);
    setVisible(true);
  };

  const onClose = () => {
    setInvoiceData(null);
    setVisible(false);
  };

  const filteredHistory = salehistory?.filter((customer) =>
    customer?.sale_status?.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <ToastContainer />
      <div className="px-4 sm:px-6 lg:px-8">
        <div className="sm:flex sm:items-center">
          <div className="sm:flex-auto">
            <h1 className="text-base font-semibold text-gray-900">
              Sale Invoices
            </h1>
            <p className="mt-2 text-sm text-gray-700">
              A list of all the Sale Invoices in your account including their
              status, amount and customer Name.
            </p>
          </div>
          <div className="  mt-4 sm:ml-16 sm:mt-0 sm:flex-none">
            <input
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              placeholder="Search Customer"
              className="border p-2 rounded-full w-64"
            />
          </div>
        </div>
        <div className="mt-8 flow-root">
          <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <table className="min-w-full divide-y divide-gray-300">
                <thead>
                  <tr>
                    <th
                      scope="col"
                      className="py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-0"
                    >
                      No.
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Order Id
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Customer Name
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Products
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Status
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Amount
                    </th>
                    <th
                      scope="col"
                      className="px-3 py-3.5 text-left text-sm font-semibold text-gray-900"
                    >
                      Invoice
                    </th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-gray-200">
                  {filteredHistory?.map((invoice, index) => (
                    <tr key={index}>
                      <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-0">
                        {index + 1}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        {(invoice?.order_id).slice(0, 14) + "..."}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        {invoice.customer_name}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        {invoice.product_names?.split(",")?.length}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        {invoice.sale_status}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        {" "}
                        {invoice.sale_status === "canceled"
                          ? "NA"
                          : invoice.total_paid_amount /
                            (invoice?.product_names?.split(",")?.length || 1)}
                      </td>
                      <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                        <FaFileInvoice
                          onClick={() => handleInvoice(invoice)}
                          className="text-green-500 text-2xl"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      {visible && (
        <SaleInvoiceModal
          visible={visible}
          data={invoiceData}
          onClose={onClose}
        />
      )}
    </>
  );
}
